<template>
  <Toast :close-tip="false" class="wechat" :close-event="closeEvent">

    <p class="descript">点击<span>右上角</span>，邀请好友领取<br>
      您和好友都可获得<span>专属优惠券</span></p>
    <img src="@/assets/img/wx-share-coupon.png"
      srcset="@/assets/img/wx-share-coupon@2x.png 2x,@/assets/img/wx-share-coupon@3x.png 3x">
  </Toast>
</template>

<script>
import Toast from "./../VueToast"
export default {
  name: 'FailShare',
  props: {
    closeEvent: Function
  },
  components: {
    Toast
  },
  methods: {
  }

}
</script>

<style lang="scss" scoped>
.wechat {
  display: block;
  .descript {
    width: 250px;
    height: 50px;
    background-image: url("./../../../assets/img/wx-share-bg.png");
    background-repeat: no-repeat;
    font-family: PingFangSC-Medium;
    font-size: 12px;
    line-height: 16px;
    text-align: justify;
    padding-top: 28px;
    padding-left: 20px;
    margin-left: 25px;
    color: #ffffff;
    span {
      color: rgb(255, 196, 99);
    }
  }
  .toast__content {
    background-color: transparent;
    margin: 0 auto;
  }
}
</style>